<script></script>

<template>
  <div
    class="position-absolute bg-transparent w-100 top-0 left-0 pt-4 px-lg-7"
  >
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center bg-transparent"
    >
      <img
        src="https://ventusleasing.mx/wp-content/uploads/2023/04/Logotipo-Ventus-Leasing-Arrendamiento-Puro-Financiamiento-Activos-1-1.png"
        width="240"
      />
      <div class="mt-4 mt-md-0">
        <a href="https://api.whatsapp.com/send/?phone=%2B528715060593&text&type=phone_number&app_absent=0" target="_blank" class="btn btn-warning text-dark shadow-none rounded-pill mb-0">
          Contacta a un asesor
        </a>
        <a href="https://ventusleasing.mx/pre-aprueba-tu-linea-paso-1-crea-tu-cuenta-o-inicia-sesion/" target="_blank" class="btn bg-dark text-white rounded-pill mb-0 shadow-none">
          Pre-aprueba tu línea
        </a>
      </div>
    </div>
  </div>
</template>
